export function readLocalItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeLocalItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Ignore quota / private mode failures.
  }
}

export function readLocalJson<T>(key: string): T | null {
  try {
    const raw = readLocalItem(key);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as unknown;
    if (parsed == null || typeof parsed !== 'object') {
      return null;
    }
    return parsed as T;
  } catch {
    return null;
  }
}

export function writeLocalJson(key: string, value: unknown): void {
  try {
    writeLocalItem(key, JSON.stringify(value));
  } catch {
    // Ignore quota / private mode failures.
  }
}

export function removeLocalItem(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // Ignore storage failures.
  }
}
